import loadable from '@loadable/component';

const MainPage = loadable(() => import('./MainPage'));

export { MainPage };
